import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-61a9dd88"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "media-loader" }
const _hoisted_2 = {
  key: 1,
  class: "media-loader-error"
}

import PlatformLinks from '@/components/PlatformLinks.vue';
import Spinner from '@/components/Spinner.vue';
import { ref } from 'vue';
import LazyMedia from './LazyMedia.vue';

type LoadingState = 'loading' | 'failed' | 'loaded';
type MediaLoaderProps = {
  image?: string;
  media: string | null | undefined;
  showDownload?: boolean;
  showLinks?: boolean;
  showVideoControls?: boolean;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'MediaLoader',
  props: {
    image: null,
    media: null,
    showDownload: { type: Boolean },
    showLinks: { type: Boolean },
    showVideoControls: { type: Boolean }
  },
  setup(__props: any) {


const state = ref<LoadingState>('loading');

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (state.value ==='loading')
      ? (_openBlock(), _createBlock(Spinner, { key: 0 }))
      : (state.value === 'failed')
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _renderSlot(_ctx.$slots, "error")
          ]))
        : _createCommentVNode("", true),
    (__props.media || __props.image)
      ? (_openBlock(), _createBlock(LazyMedia, {
          key: 2,
          src: __props.media || __props.image || '',
          poster: __props.image || '',
          onLoad: _cache[0] || (_cache[0] = ($event: any) => (state.value = 'loaded')),
          onError: _cache[1] || (_cache[1] = ($event: any) => (state.value = 'failed')),
          "show-controls": __props.showVideoControls || false
        }, null, 8, ["src", "poster", "show-controls"]))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "injector"),
    (__props.showLinks)
      ? (_openBlock(), _createBlock(PlatformLinks, {
          key: 3,
          id: "campaign-complete-info-platform-links"
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})